var _style, _linearGradient, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoaderSlim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgSlim",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "25 25 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.slimPath{fill:url(#slimGradient);}\r\n\t")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "slimGradient",
    gradientUnits: "userSpaceOnUse",
    x1: 27.093,
    y1: 782.5,
    x2: 72.8076,
    y2: 782.5,
    gradientTransform: "matrix(1 0 0 1 0 -744)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "slimPath",
    d: "M29.1,50c1,0,1.8-0.8,1.9-1.8c0.9-9.7,9-17.3,19-17.3s18.1,7.6,19,17.3c0.1,1,0.9,1.8,1.9,1.8l0,0 c1.1,0,2.1-1,2-2.1C71.9,36.2,62.1,27,50.1,27s-21.8,9.2-22.9,20.9C27.1,49,28,50,29.1,50L29.1,50z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    accumulate: "none",
    additive: "replace",
    attributeName: "transform",
    attributeType: "XML",
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    from: "0 50 50",
    repeatCount: "indefinite",
    restart: "always",
    to: "360 50 50",
    type: "rotate"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderSlim);
export default __webpack_public_path__ + "static/media/loader-slim.b837b359.svg";
export { ForwardRef as ReactComponent };